export default __webpack_public_path__ + "static/media/dust-check.6965a83a.png";